export default "__VITE_PUBLIC_ASSET__89ae0981__"